import React, { Component } from 'react';
import { Table } from 'semantic-ui-react';

class DatesWithProductionFromMultiplePracticesTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sortedData: props.data,
            sortColumn: null,
            sortDirection: null,
        };
    }

    handleSort = (clickedColumn) => {
        const { data } = this.props;
        const { sortColumn, sortDirection } = this.state;

        if (sortColumn !== clickedColumn) {
            this.setState({
                sortedData: [...data].sort((a, b) => a[clickedColumn].localeCompare(b[clickedColumn])),
                sortColumn: clickedColumn,
                sortDirection: 'ascending',
            });
        } else {
            this.setState({
                sortedData: [...data].reverse(),
                sortDirection: sortDirection === 'ascending' ? 'descending' : 'ascending',
            });
        }
    };

    render() {
        const { sortedData, sortColumn, sortDirection } = this.state;

        return (
            <Table sortable celled fixed>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell
                            sorted={sortColumn === 'dateProviderKey' ? sortDirection : null}
                            onClick={() => this.handleSort('dateProviderKey')}
                        >
                            Date
                        </Table.HeaderCell>
                        <Table.HeaderCell
                            sorted={sortColumn === 'practiceNames' ? sortDirection : null}
                            onClick={() => this.handleSort('practiceNames')}
                        >
                            Practices
                        </Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {sortedData.map((row, index) => (
                        <Table.Row key={index}>
                            <Table.Cell>{row.dateProviderKey.split('_')[0]}</Table.Cell>
                            <Table.Cell>{row.practiceNames.join(', ')}</Table.Cell>
                        </Table.Row>
                    ))}
                </Table.Body>
            </Table>
        );
    }
}

export default DatesWithProductionFromMultiplePracticesTable;